import { Component, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { LayoutService } from '../../core/services/layout/layout.service';

@Component({
  selector: 'app-sidebar-menu',
  templateUrl: './sidebar-menu.component.html',
  styleUrls: ['./sidebar-menu.component.scss'],
  imports: [RouterLink, RouterLinkActive],
})
export class SidebarMenuComponent implements OnInit {
  public menuItems = [
    {
      label: 'Dashboard',
      icon: 'ri ri-dashboard-2-line',
      link: '/dashboard',
    },
    {
      label: 'My Order',
      icon: 'ri ri-archive-line',
      link: '/my-order/order-list/order-draft',
    },
    {
      label: 'Spot Rate',
      icon: 'ri-discount-percent-line',
      link: '/spot-rate/spot-rate-list/new-request',
    },
    {
      label: 'Rate Calculator',
      icon: 'ri ri-calculator-line',
      link: '/rate-calculator/rateCalculator-form',
    },
    {
      label: 'Billings',
      icon: 'ri ri-wallet-2-line',
      link: '/billing/billing-list/recharge-logs',
    },
    {
      label: 'Warehouse',
      icon: 'ri ri-home-gear-line',
      link: '/warehouse/warehouse-list',
    },
    {
      label: 'Settings',
      icon: 'ri ri-settings-5-line',
      id: 'settings',
      subMenus: [
        // { label: 'Plan Mgmt.', link: '/setting/plan-mgmt' },
        { label: 'Consignor List ', link: '/setting/consignor-list' },
      ],
    },
  ];

  constructor(private layout: LayoutService) {}

  ngOnInit() {
    console.log('Sidebar Loaded');
  }

  openSubmenuId: string | null = null;

  toggleSubmenu(id: string) {
    this.openSubmenuId = this.openSubmenuId === id ? null : id;
  }

  closeSidebar() {
    this.layout.close();
  }
}
